var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.foodProfilesByHour),function(foodData,foodType){return _c('AccFoodGraphics',{key:foodType,attrs:{"food-type":foodType,"food-data":foodData,"foods-by-company":_vm.foodsByCompany,"is-loading":_vm.isLoading}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }